// store/api.ts
import { rtk } from "./generated.ts";

// You can enhance endpoints with tags for cache management, as in first project
const enhancedRtkApi = rtk.enhanceEndpoints({
  addTagTypes: ["profile"],  // add more if you need for caching
  endpoints: {
    profileMeasurementsUpdateUpdate: { invalidatesTags: ["profile"] },
    profileMeasurementsUpdate: { invalidatesTags: ["profile"] },
    profileUpdateUpdate: { invalidatesTags: ["profile"] },
    getMyBodyType: { providesTags: ["profile"] },
    getMyFaceShape: { providesTags: ["profile"] },
    getMyColorAnalysis: { providesTags: ["profile"] },
    profileRead: { providesTags: ["profile"] },
    // add more if needed for cache control!
  },
});

// Export everything needed by UI
export * from "./generated.ts";
export { enhancedRtkApi as api };
